import { httpService } from "../http";
const REACT_APP_GO_MICRO = process.env.REACT_APP_GO_MICRO;

export interface IUrbanCarbonRankItem {
  sort: number;
  nikeName: string;
  avatar: string;
  pushNum: number;
  likeNum: number;
}
// 获取排行榜数据
export const getUrbanCarbonRankList = async (): Promise<{ ranking: IUrbanCarbonRankItem[], rank: IUrbanCarbonRankItem }> => {
  return httpService.get(`/mp2c-micro/community/topic/seeking_store/ranking`, {}, { baseURL: REACT_APP_GO_MICRO });
}
